<template>
  <div>
    <x-grid :id="'childGrid'"
            :columns="columns"
            :toolbar-config="toolbarConfig"
            :editable="true"
            :edit-rules="editRules"
            :editConfig="editConfig"
            ref="grid"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="visible = true">新增</vxe-button>
        <vxe-button @click="delRow()">删除</vxe-button>
      </template>
    </x-grid>

    <a-modal forceRender
             v-model="visible"
             title="选择部门"
             :width="800"
             ok-text="确认"
             cancel-text="取消"
             @ok="setTableData"
             @cancel="cancelSet">
      <planPicker v-if="visible" ref="userPicker" :navSwitch="navSwitch" :trueOrFalse="trueOrFalse" :deptId="deptId" @getTreeData="getTreeData"></planPicker>
    </a-modal>
  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridChild'
import {GridChildMixin} from "@/utils/GridChildMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
// import {loadBaseCodeData} from "@/services/baseCodeSource";
// import {dataApi} from "@/services/clue/clueManage";

const fac = XGrid.factory;
console.info(fmt);//防止不使用便利 eslint报错

//弹出层组件
import planPicker from '@/components/picker/planDeptPicker.vue';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn({
    field: 'deptName',
    title: '经理部',
    width: 100,
    align: 'center',
  }),
  // fac.makeColumn({
  //   field: "planDistributeNum",
  //   title: "数量",
  //   width: 120,
  //   align: 'center',
  //   editRender: {
  //     name: 'input',
  //     attrs:{
  //       type: 'number'
  //     },
  //   },
  //   editRules: [{required: true}],
  //   formatter(cellValue) {
  //     console.log(cellValue)
  //     if(cellValue.cellValue < 0){
  //       alert('请输入大于0的数字');
  //     }
  //     return fmt.formatLong({cellValue: cellValue.cellValue>0?cellValue.cellValue:0},'')
  //   },
  // }),
  // fac.makeColumn({
  //   field: "monthCount",
  //   title: "上月完成情况",
  //   width: 200,
  //   align: 'center',
  // }),
  // fac.makeColumn({
  //   field: "yearCount",
  //   title: "本年完成情况",
  //   width: 200,
  //   align: 'center',
  //
  // }),
  fac.makeColumn({
    field: "qyNum",
    title: "牵引数量",
    type: 'number',
    width: 120,
    align: 'center',
    editRender: {
      name: '$input',
      props:{
        type: 'number',
        min:1,
      },
      events: {}
    },
    editRules: [{required: true}],
  }),
  fac.makeColumn({
    field: "zhNum",
    title: "载货数量",
    type: 'number',
    width: 120,
    align: 'center',
    editRender: {
      name: '$input',
      props:{
        type: 'number',
        min:1,
      },
      events: {}
    },
    editRules: [{required: true}],

  }),
  fac.makeColumn({
    field: "gcNum",
    title: "工程数量",
    type: 'number',
    width: 120,
    align: 'center',
    editRender: {
      name: '$input',
      props:{
        type: 'number',
        min:1,
      },
      events: {}
    },
    editRules: [{required: true}],
  }),
  fac.makeColumn({
    field: "zyNum",
    title: "专用数量",
    type: 'number',
    width: 120,
    align: 'center',
    editRender: {
      name: '$input',
      props:{
        type: 'number',
        min:1,
      },
      events: {}
    },
    editRules: [{required: true}],

  }),
  fac.makeColumn({
    field: "qkNum",
    title: "轻卡数量",
    type: 'number',
    width: 120,
    align: 'center',
    editRender: {
      name: '$input',
      props:{
        type: 'number',
        min:1,
      },
      events: {}
    },
    editRules: [{required: true}],
  }),

  fac.makeColumn({
    field: "xnyNum",
    title: "新能源数量",
    type: 'number',
    width: 120,
    align: 'center',
    editRender: {
      name: '$input',
      props:{
        type: 'number',
        min:1,
      },
      events: {}
    },
    editRules: [{required: true}],
  }),
  //  新增的
//   fac.makeColumn({
//     field: "monthCount",
//     title: "上月完成情况",
//     width: 200,
//     align: 'center',
// }),
//   fac.makeColumn({
//     field: "yearCount",
//     title: "本年完成情况",
//     width: 200,
//     align: 'center',
//   }),
  fac.makeColumn({
    field: "qyMonthCount",
    title: "上月牵引完成情况",
    width: 200,
    align: 'center',
  }),
  fac.makeColumn({
    field: "zhMonthCount",
    title: "上月载货完成情况",
    width: 200,
    align: 'center',
  }),
  fac.makeColumn({
    field: "gcMonthCount",
    title: "上月工程完成情况",
    width: 200,
    align: 'center',
  }),
  fac.makeColumn({
    field: "zyMonthCount",
    title: "上月专用完成情况",
    width: 200,
    align: 'center',
  }),
  fac.makeColumn({
    field: "qkMonthCount",
    title: "上月轻卡完成情况",
    width: 200,
    align: 'center',
  }),
  fac.makeColumn({
    field: "xnyMonthCount",
    title: "上月新能源完成情况",
    width: 200,
    align: 'center',
  }),
  fac.makeColumn({
    field: "qyYearCount",
    title: "本年牵引完成情况",
    width: 200,
    align: 'center',
  }),
  fac.makeColumn({
    field: "zhYearCount",
    title: "本年载货完成情况",
    width: 200,
    align: 'center',
  }),
  fac.makeColumn({
    field: "gcYearCount",
    title: "本年工程完成情况",
    width: 200,
    align: 'center',
  }),
  fac.makeColumn({
    field: "zyYearCount",
    title: "本年专用完成情况",
    width: 200,
    align: 'center',
  }),
  fac.makeColumn({
    field: "qkYearCount",
    title: "本年轻卡完成情况",
    width: 200,
    align: 'center',
  }),
  fac.makeColumn({
    field: "xnyYearCount",
    title: "本年新能源完成情况",
    width: 200,
    align: 'center',
  }),
]

const rowIdName = 'distributeId';

//可编辑表格规则 没有特殊要求的不改
const editRules = fac.makeEditRules(columns);

//工具栏按钮 没有可删除
const toolbarConfig = fac.makeToolbarConfig({
  templatelSlots: 'toolbarBtns'
});
//编辑配置
const editConfig = fac.makeEditConfig();

// /**
//  * 加载基础数据
//  */
// async function loadBaseData() {
//   let commCodeData = await dataApi.getCommCode();
//   this.strainOptions = commCodeData.data.strain.map(v => {
//     return {
//       label: v.code_name,
//       value: v.code_id
//     }
//   })
// }

export default {
  mixins: [GridChildMixin],
  props:{
    tabsFlag:{
      type:[Number,String],
    },
    navSwitch:{
      type:Number,
    },
    deptId:{
      type:Number,
    },
  },
  components: {
    planPicker
  },
  data() {
    return {
      rowIdName,
      toolbarConfig,
      editRules,
      columns,
      sumCount:0,
      editConfig,
      editRowId: -1,
      loyalTypeOptions:[],
      tableData:[],
      trueOrFalse:false
    }
  },
  watch:{
    tabsFlag(nv){
      let columnsTitle = '',fieldName = '';
      console.log(nv)
      if(nv == 1){
        columnsTitle = '经理部';
        fieldName = 'deptName';

      }else if(nv == 2){
        columnsTitle = '经销商';
        fieldName = 'deptName'
      }else {
        fieldName = 'userName'
        columnsTitle = '销售顾问';
      }
      this.$set(this.columns,1,Object.assign({},this.columns[1],{title:columnsTitle}))
      this.$set(this.columns,1,Object.assign({},this.columns[1],{field:fieldName}))
    }
  },
  mounted() {
    console.log(this.navSwitch);
    let columnsTitle = '',fieldName = '';
    if(this.navSwitch === 0){
      columnsTitle = '经理部';
      fieldName = 'deptName';
    }else if(this.navSwitch === 1){
      this.trueOrFalse=true;
      console.log(this.trueOrFalse)
      columnsTitle = '经销商';
      fieldName = 'deptName'
    }else if(this.navSwitch === 2){
      columnsTitle = '销售顾问';
      fieldName = 'userName'
    }
    this.$set(this.columns,1,Object.assign({},this.columns[1],{title:columnsTitle}))
    this.$set(this.columns,1,Object.assign({},this.columns[1],{field:fieldName}))
    this.refresh()
  },
  methods: {
    closePop() {
      this.editRowId = -1;
      this.visible = false;
    },
    getTreeData(res){
      this.tableData = res;
    },
    setTableData(){
      this.$emit('setTable',this.tableData)
      this.visible = false;
    },
    cancelSet(){
      this.visible = true;
      this.tableData = [];
    }
    // loadBaseData
  }
}
</script>

<style scoped lang="stylus">
/deep/ .vxe-toolbar {
  padding-left 0;
  height 40px!important;
}
</style>
